import React from 'react'
import { Box, Typography } from '@mui/material'
import IconInterax from './Icon'
import Button from './Button'
import { INTERAX_COLORS } from '../constants/colors'

export interface DashboardInfoBoxProps {
  icon: React.ReactNode
  heading: string
  description: string
  linkText: string
  linkIcon?: React.ReactNode
  onLinkClick?: () => void
  className?: string
}

const DashboardInfoBox: React.FC<DashboardInfoBoxProps> = ({
  icon,
  heading,
  description,
  linkText,
  linkIcon,
  onLinkClick,
  className = ''
}) => {
  return (
    <Box
      className={className}
      sx={{
        backgroundColor: INTERAX_COLORS.heritageBlue40,
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        width: '100%',
        height: '100%',
        p: { xs: 3, sm: 4, md: 5 }
      }}
    >
      {/* Top section - Icon and Content */}
      <Box
        sx={{
          display: 'flex',
          gap: 3,
          flex: 1,
          alignItems: 'flex-start',
          minHeight: 0
        }}
      >
        {/* Left side - Icon with box background */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', pt: 0.5 }}>
          <IconInterax backgroundShape="square" size="large" iconClassName="medium">
            {icon}
          </IconInterax>
        </Box>

        {/* Right side - Content */}
        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            minHeight: 0
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: INTERAX_COLORS.white,
              fontWeight: 600,
              lineHeight: '28px'
            }}
          >
            {heading}
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: INTERAX_COLORS.thunderGrey,
              lineHeight: '24px',
              flexGrow: 1,
              minHeight: 0
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>

      {/* Bottom section - Button aligned to bottom-right */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 'auto' }}>
        <Button
          variant="secondary"
          size="medium"
          onClick={onLinkClick}
          icon={linkIcon}
          iconPosition="right"
          className="group"
        >
          {linkText}
        </Button>
      </Box>
    </Box>
  )
}

export default DashboardInfoBox
